import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExceptionEventType } from "../types/ExceptionEventType";
import { apiClient } from "src/utils/Api/apiClient";

interface allExceptionEventState {
        exceptionEvents: Array<ExceptionEventType>;
        exceptionEventsLoading: boolean;
        exceptionEventsError: string | null;
}

const initialState: allExceptionEventState = {
        exceptionEvents: [],
        exceptionEventsLoading: true,
        exceptionEventsError: null
}

export const getExceptionEvents = createAsyncThunk(
        'dealers/getExceptionEvents',
        async (dealerID: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`dealer/getExceptionEvents/${dealerID}`);
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

const exceptionEventSlice = createSlice({
        name: 'exceptionEvent',
        initialState,
        reducers: {
                dealerDetailReset: () => initialState,
                insertExceptionEvent: (state, action) => {
                        console.log("Inside insert exception event");
                        state.exceptionEvents.push(action.payload);
                },
                removeExceptionEvent: (state, action) => {
                        console.log("Inside reomve exception event");
                        state.exceptionEvents.pop();
                },
        },
        extraReducers: (builder) => {
                //get all Dealers from server
                builder.addCase(getExceptionEvents.pending, (state) => {
                        state.exceptionEventsLoading = true;
                        state.exceptionEventsError = null;
                });
                builder.addCase(getExceptionEvents.fulfilled, (state, action) => {
                        state.exceptionEventsLoading = false;
                        state.exceptionEvents = action.payload;
                });
                builder.addCase(getExceptionEvents.rejected, (state, action) => {
                        state.exceptionEventsLoading = false;
                        state.exceptionEventsError = action.payload as string;
                });
        }
});

export const { dealerDetailReset, insertExceptionEvent, removeExceptionEvent } = exceptionEventSlice.actions;
export default exceptionEventSlice.reducer;
